<template>
  <div class="booking-form__receiver">
    <div class="container-fluid">
      <div class="row">
        <div class="col customer-type">
          <div class="flex justify-between items-center">
            <div>
              <h3 class="label text-md">
                Receiver
                <tool-tip text="Recipient of the goods being shipped." />
              </h3>
            </div>
          </div>
          <div class="d-flex mt-3 mb-4">
            <label class="radio-label" for="business-customer">
              <input
                type="radio"
                id="business-customer"
                value="business"
                v-model="consignee.customerType"
              />
              Business Customer
              <span></span>
            </label>
            <label class="radio-label ml-4" for="private-customer">
              <input
                type="radio"
                id="private-customer"
                value="private"
                v-model="consignee.customerType"
              />
              Private Customer
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <label for="name" class="label">Name</label>
            <input
              type="text"
              class="input"
              placeholder="Enter Name"
              v-model="consignee.contactName"
            />
          </div>
        </div>
        <div
          class="col-sm-12 col-md-12 col-lg-6"
          v-if="consignee.customerType == 'business'"
        >
          <div class="input-wrapper">
            <label class="label">Contact Person</label>
            <input
              type="text"
              v-model="consignee.contactPerson"
              class="input"
              placeholder="Enter Contact Person"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <label class="label">Email</label>
            <input
              type="email"
              class="input"
              placeholder="Enter email"
              v-model="consignee.email"
            />
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Phone Number</label>
              <div class="flex">
                <label class="radio-label" for="mobile">
                  <input
                    type="radio"
                    id="mobile"
                    value="mobile"
                    v-model="phoneNumberType"
                  />
                  Mobile
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="fixed">
                  <input
                    type="radio"
                    id="fixed"
                    value="fixed"
                    v-model="phoneNumberType"
                  />
                  Fixed
                  <span></span>
                </label>
              </div>
            </div>
            <div class="">
              <vue-tel-input
                :preferredCountries="['Nigeria']"
                v-model="consignee.mobile"
              ></vue-tel-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Address</label>

              <div class="flex">
                <label class="radio-label" for="residential">
                  <input
                    type="radio"
                    id="residential"
                    value="residential"
                    v-model="addressType"
                  />
                  Residential
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="business">
                  <input
                    type="radio"
                    id="business"
                    value="business"
                    v-model="addressType"
                  />
                  Business
                  <span></span>
                </label>
              </div>
            </div>
            <vue-google-autocomplete
              id="map"
              ref="consigneeAddress"
              classname="input"
              placeholder="Enter address"
              v-on:placechanged="getAddress"
            >
            </vue-google-autocomplete>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="input-wrapper" style="width: 95%">
            <base-checkbox
              v-model="consignee.sendShippingUpdates"
              label="Share status updates with Receiver.."
            />
          </div>
        </div>
      </div>

      <div class="button-wrapper">
        <p class="cursor-pointer underline" @click="$emit('back-one-form')">
          Back
        </p>
        <span class="mr-6">
          <base-button
            text="Continue"
            :loading="isLoading"
            @click="handleSubmit"
          />
        </span>
      </div>
    </div>
    <load-consignee-modal
      :show-modal="showLoadConsigneeModal"
      @form-loaded="formLoaded"
      @close-modal="showLoadConsigneeModal = false"
    />
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "consignee-form",
  components: {
    VueGoogleAutocomplete,
  },
  data() {
    return {
      consignee: {
        email: "",
        mobile: "",
        customerType: "business",
        city: null,
        state: null,
        country: "",
        zipCode: "",
        contactName: "",
        address: "",
        sendShippingUpdates: false,
      },
      showLoadConsigneeModal: false,
      address: {
        name: "",
        lat: 0.0,
        lng: 0.0,
      },
      addressType: "business",
      phoneNumberType: "mobile",
      states: [],
      countries: ["Nigeria"],
      cities: [],
      isLoading: false,
      isDeleteModal: false,
      transactionId: "",
      hasState: true,
      hasCity: true,
      errorMessage: "",
      terminalsExist: false,
    };
  },
  watch: {
    "consignee.customerType"(val) {
      if (val == "business") {
        this.addressType = "business";
      } else {
        this.addressType = "residential";
      }
    },

    isNewConsignee(val) {
      if (val) {
        this.consignee = {
          email: "",
          mobile: "",
          type: "delivery",
          customerType: "business",
          city: "",
          state: "",
          country: "",
          zipCode: "",
          contactName: "",
          address: {
            name: "yaba",
            lat: 6.123,
            lng: 3.456,
          },
        };
      }
    },
    "consignee.mobile"(val) {
      if (val.length <= 12) {
        this.shipper.mobile = val;
      } else {
        this.shipper.mobile = val.trim().substring(0, 12);
      }
    },
    "$store.state.bookingModule.lastCompletedFormNo"() {
      if (this.$store.state.bookingModule.lastCompletedFormNo == this.formNo) {
        if (this.$store.getters.consigneeInformation.id.length > 0) {
          this.consignee = { ...this.$store.getters.consigneeInformation };
        }
      }
    },
    consignee: {
      handler: function () {
        this.mustUpdate = true;
      },
      deep: true,
    },
  },
  computed: {
    isNewConsignee() {
      return this.$store.getters.isNewConsignee;
    },
    consolidationId() {
      return this.$store.getters.getShipConsolidationID;
    },
  },
  mounted() {
    this.getAllStates().then(() => {
      this.filterCity();
    });

    this.consignee = { ...this.$store.getters.consigneeInformation };

    this.$refs.consigneeAddress.update(
      this.formatAddress(this.consignee.address)
    );
    this.address = this.consignee.address;

    if (this.$store.getters.consigneeLocationPreselected) {
      this.consignee = {
        ...this.$store.getters.consigneeInformation,
      };

      this.address = this.consignee.address;
      this.$refs.consigneeAddress.update(
        this.formatAddress(this.consignee.address)
      );
      delete this.consignee.updatedAt;
      delete this.consignee.createdAt;
    }
  },
  methods: {
    filterCity() {
      this.cities = [];
      if (this.consignee.state?.length > 0) {
        this.cities = [
          ...this.states.find((state) => state.name == this.consignee.state)
            .cities,
        ];
      }
    },

    formLoaded() {},
    async handleSubmit() {
      this.isLoading = true;
      this.errorMessage = "";
      await this.checkTerminals();

      if (this.terminalsExist) {
        if (this.consignee.id && !this.mustUpdate) {
          this.mustUpdate = false;
          this.getShippingServices();
        } else {
          this.submitConsigneeInformation();
        }
      } else {
        this.isLoading = false;
        this.generateToast(`${this.errorMessage}`, "error");
      }

      this.mustUpdate = false;
    },
    async checkTerminals() {
      let shipperAdd = this.$store.getters.shipperInformation.address;
      const payload = {
        orgId: this.$store.state.authentication.organizationId,
        arrivalLocation: {
          lat: this.address.lat,
          lng: this.address.lng,
        },
        takeOffLocation: {
          lat: shipperAdd.lat,
          lng: shipperAdd.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);

        let takeOffArray = [];
        let pickUpArray = [];

        takeOffArray = response.data.data.takeOffLocation;
        pickUpArray = response.data.data.arrivalLocation;

        if (takeOffArray.length > 0 && pickUpArray.length == 0) {
          this.errorMessage =
            "Terminals does not exist for the selected address for the Sender Receiver. Please select another location with existing terminals before proceeding";
        } else if (takeOffArray.length == 0 && pickUpArray.length > 0) {
          this.errorMessage =
            "Terminals does not exist for the selected address for the Sender. Please select another location with existing terminals before proceeding";
        } else if (takeOffArray.length == 0 && pickUpArray.length == 0) {
          this.errorMessage =
            "Terminals does not exist for the selected address for the Sender and Receiver. Please select another location with existing terminals before proceeding";
        }

        if (takeOffArray.length > 0 && pickUpArray.length > 0) {
          this.terminalsExist = true;
        } else {
          this.terminalsExist = false;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async submitConsigneeInformation() {
      this.isLoading = true;

      this.consignee.address = this.address;
      try {
        let payload = {
          contactName: this.consignee.contactName,
          email: this.consignee.email,
          mobile: this.consignee.mobile,
          customerType: this.consignee.customerType,
          type: this.consignee.type,
          address: this.consignee.address,
          country: this.consignee.country,
          zipCode: this.consignee.zipCode,
          sendShippingUpdates: this.consignee.sendShippingUpdates,
          contactPerson: this.consignee.contactPerson,
          mobileNumberType: this.consignee.mobileNumberType,
          addressType: this.consignee.addressType,
        };
        const response = await this.$_submitConsigneeInformation(payload);
        this.handleResponse(response);
      } catch (error) {
        this.isLoading = false;
        this.handleError(error);
      }

      this.isLoading = false;
    },
    handleResponse(response) {
      this.$store.dispatch("saveBookingInformation", {
        property: "consignee",
        value: response.data.data,
      });
      this.mustUpdate = false;
      this.$store.dispatch("saveDeliveryLocationId", response.data.data.id);
      this.$store.dispatch("saveLastCompletedFormNo", 2);
      this.createShippingId();
    },
    async createShippingId() {
      const payload = {
        payload: {
          id: this.$store.state.bookingModule.shippingId,
          shipperLocationId: this.$store.getters.takeOffLocationId,
          consigneeLocationId: this.$store.getters.deliveryLocationId,
          paymentStatus: "Not paid",
          shippingServiceId: null,
          deliveryConfirmation: false,
          currentStep: 2,
        },
      };
      if (this.consolidationId) {
        payload.payload.consolidationId = this.consolidationId;
      }
      this.$_createShippingId(payload)
        .then((response) => {
          this.$store.dispatch(
            "saveShippingId",
            response.data.data.shipping.id
          );
          this.$emit("change-form");
          // this.getShippingServices();
        })
        .catch((e) => {
          this.handleError(e);
        });
      this.isLoading = false;
    },

    async getAllStates() {
      try {
        let response = await this.$_getAllStatesAndCities();
        this.states = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },

    getAddress(addressData) {
      this.address.name = addressData.route;
      this.address.lat = addressData.latitude;
      this.address.lng = addressData.longitude;
      this.consignee.country = this.countries[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-form__receiver {
  padding: 2rem 2.5rem;
}

.label {
  color: var(-primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.check-label {
  font-size: 0.9rem;
}

.input,
.vti__input,
.vue-tel-input {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  height: 2.65rem !important;
}

.input::placeholder {
  color: #bec4d5;
}

.customer-type {
  margin: 1rem 1.5rem;
}

.input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
}

.customer-type h3 {
  font-size: 1.2rem;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
